<template>
  <div>
    <div class="d-flex align-items-center mb-4">
      <base-button tag="router-link" to="/product" icon="arrow-left"  bg="transparent" w="unset" h="unset" class="me-3"  fs-icon="3"/>
      <h-title>Add New Product</h-title>
    </div>
    <div class="row">
      <div class="col-xl-3 col-12 pb-4">
        <base-box bordered p="2rem">
          <base-box-img id="base-image" is-thumbnail />
          <div class="row mt-3">
            <div class="col-lg-4 col-12">
                <base-box-img id="product-1" with-remove />
            </div>
            <div class="col-lg-4 col-12">
                <base-box-img id="product-2" with-remove />
            </div>
            <div class="col-lg-4 col-12">
                <base-box-img id="product-3" with-remove />
            </div>
          </div>
        </base-box>
      </div>
      <div class="col-xl-7 col-12">
        <base-box align="center" justify="between" class="mb-4" p="1.25rem 2rem" bordered>
          <h-title tag="h5" class="m-0">Type Product</h-title>
          <base-select :options="[{value: 'single', text: 'Single Product'}, {value: 'variant', text: 'Variant Product'}]" />
        </base-box>
        <base-box p="1.25rem 2rem" class="mb-4" bordered>
          <base-collapse id="primaryProduct" title="Primary Details">
            <base-input :is-gray=false placeholder="Product Title" class="mb-3" is-bordered></base-input>
            <base-input :is-gray=false placeholder="Short Desctiption" tag="textarea" rows="4" class="mb-3 pt-4 pb-4" is-bordered></base-input>
            
            <base-input :is-gray=false placeholder="Type Category ..." class="mb-3" is-bordered></base-input>
            <base-input :is-gray=false placeholder="Type Tags ..." class="mb-3" is-bordered></base-input>
          </base-collapse>
        </base-box>

        <!-- VARIANT -->
        <base-box p="1.25rem 2rem" class="mb-4" bordered>
          <base-collapse id="variantProduct" title="Variation Product" >
            <transition-group name="pop" tag="div" class="position-relative" @enter="enter" @leave="leave" @after-enter="afterEnter">
            <div v-for="variant,index in variants" :key="variant" :id="`variantProduct${index}`" class="row">
              <div class="col-12 mb-1">
                <base-button @click="removeVariant(variant)" icon="times" bg="black" w="29px" h="29px" fs-icon="6"  d="inline-flex" justify="center" no-focus></base-button>
                <span class="text-gray ms-2">#{{ index+1 }}</span>
              </div>
              <div class="col-lg-2 col-12 mb-2">
                <base-box-img :id="`variant-${index}`" class="h-100" />
              </div>
              <div class="col-lg-10 col-12 mb-2">
                <div class="row">
                  <div class="col-lg-4 col-12 py-2">
                    <base-select bg="white" size="xl" :options="[{value: 'size', text: 'Size'}, {value: 'color', text: 'Color'}]"></base-select>
                  </div>
                  <div class="col-lg-4 col-12 py-2">
                    <base-input 
                      :modelValue="variant.name"
                      @update:modelValue="value => variant.name = value" 
                      placeholder="Variant Name" :isGray=false is-bordered></base-input>
                  </div>
                  <div class="col-lg-4 col-12 py-2">
                    <base-input 
                      :modelValue="variant.regulerPrice"
                      @update:modelValue="value => variant.regulerPrice = value" type="number" label="Regular Price" :isGray=false is-float is-bordered></base-input>
                  </div>
                  <div class="col-lg-4 col-12 py-2">
                    <base-input type="text" 
                      :modelValue="variant.sku"
                      @update:modelValue="value => variant.sku = value" placeholder="SKU" :isGray=false is-bordered></base-input>
                  </div>
                  <div class="col-lg-4 col-12 py-2">
                    <base-input type="number" 
                      :modelValue="variant.stock"
                      @update:modelValue="value => variant.stock = value" label="Stock" :isGray=false is-float is-bordered></base-input>
                  </div>
                  <div class="col-lg-4 col-12 py-2">
                    <base-input type="number" 
                      :modelValue="variant.salePrice"
                      @update:modelValue="value => variant.salePrice = value" label="Sale Price" :isGray=false is-float is-bordered></base-input>
                  </div>
                </div>
              </div>
            </div>
            </transition-group>
            <base-button h="80" p="1.5rem" bg="transparent" class="d-block w-100" justify="center" no-focus cl-border="dashed" @click="addRow">
              <i class="fas fa-plus"></i>
            </base-button>
          </base-collapse>
        </base-box>

        <!-- LONG INFORMATION -->
        <base-box p="1.25rem 2rem" class="mb-5" bordered>
          <base-collapse id="additionalInformation" title="Additional Information">
            <base-input :is-gray=false placeholder="Long Information" tag="textarea" rows="4" class="mb-3 pt-4 pb-4" is-bordered></base-input>
            
          <base-box p=".75rem 1.25rem" align="center" justify="between" bordered>
            <base-switch id="sizeGuide" name="Size Guideleine" />
            <base-select bg="transparent" :options="[{value: 'draft', text: 'Draft'}, {value: 'publish', text: 'Publish'}]" />
          </base-box>
          </base-collapse>
        </base-box>
      </div>
      <div class="col-xl-2 col-lg-4 col-12">
        <base-box p="1.25rem 2rem" class="mb-3" bordered>
          <h-title class="mb-4">Settings</h-title>
          <base-select :options="[{value: 'draft', text: 'Draft'}, {value: 'publish', text: 'Publish'}]" />
        </base-box>
        <div class="row">
          <div class="col py-1">
            <base-button bg="white">Draft</base-button>
          </div>
          <div class="col py-1">
            <base-button>Publish</base-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { createApp } from 'vue';
import { reactive } from 'vue';
// import { ref } from 'vue';
import BaseSelect from '@/components/input/BaseSelect'
import BaseButton from '@/components/BaseButton';
import BaseCollapse from '@/components/BaseCollapse';
import hTitle from '@/components/text/BaseTitle';
import BaseBox from '@/components/BaseBox';
import BaseBoxImg from '@/components/BaseBoxImg';
import BaseInput from '@/components/input/BaseInput';
import BaseSwitch from '@/components/input/BaseSwitch';

export default {
  setup() {
    const variants = reactive([]);

    const addRow = () => {
      const id = Math.random()
      const newRow = reactive({
        id: id,
        image: '',
        size: '',
        name: '',
        regulerPrice: '',
        sku: '',
        stock: '',
        salePrice: ''
      });
      // variants.value = [{newRow, id}, ...variants.value]
      variants.push(newRow)
    }
    //   variants.value = [{newRow, id}, ...variants.value]
    //   variants.value = variants.value.push(newRow)
    //   variants.push(newRow)
    // }

    const removeVariant = (s) => {
      const index = variants.indexOf(s);
			variants.splice(index,1);
    }



    return {
      variants,
      addRow,
      removeVariant
    }
  },
  mounted() {
      this.$store.state.transPanelMenu = 69;
  },
  methods: {
    enter(element) {
      element.style.position = 'absolute';
      element.style.visibility = 'hidden';
      element.style.height = 'auto';

      const height = element.offsetHeight + 45 + 'px';
      console.log(height)

      element.style.position = null;
      element.style.visibility = null;
      element.style.height = 0;

      // Force repaint to make sure the
      // animation is triggered correctly.
      // getComputedStyle(element).height;

      // Trigger the animation.
      // We use `requestAnimationFrame` because we need
      // to make sure the browser has finished
      // painting after setting the `height`
      // to `0` in the line above.
      requestAnimationFrame(() => {
        element.style.height = height;
      });
    },
    afterEnter() {
      // element.style.height = 'auto';
    },
    leave(element) {
      const height = getComputedStyle(element).height;
      
      element.style.height = height;

      // Force repaint to make sure the
      // animation is triggered correctly.
      getComputedStyle(element).height;

      requestAnimationFrame(() => {
        element.style.height = 0;
      });
    }
    // addRow() {
    //   this.variants.push(this.newRow);
    // },
    // removeVariant(s) {
    //   const index = this.variants.indexOf(s);
		// 	this.variants.splice(index,1);
    // }
  },
  components: {
    BaseSelect,
    BaseButton,
    hTitle,
    BaseBox,
    BaseBoxImg,
    BaseCollapse,
    BaseInput,
    BaseSwitch
  }
}
</script>

<style>
  .pop-move,
  .pop-leave-active,
  .pop-enter-active {
    transition: all 0.5s ease;
  }
  .pop-leave-active{
    /* position: absolute; */
  }
  .pop-leave-to,
  .pop-enter-from{
    opacity: 0;
    transform: scale(0);
  }
  /* .pop-leave-from,
  .pop-enter-to{
    opacity: 1;
    transform: scale(1);
  } */
</style>